import { SuccessFetchListResponse } from "@/services/api";
import {
  InfiniteData,
  UseInfiniteQueryResult,
  UseQueryResult,
} from "@tanstack/react-query";
import { useMemo } from "react";

const useQueryData = <T>(
  query:
    | UseInfiniteQueryResult<InfiniteData<SuccessFetchListResponse<T>>>
    | UseQueryResult<SuccessFetchListResponse<T>>,
) =>
  useMemo(() => {
    if (query.isLoading) return [];
    if (!query.data) return [];
    if ("pages" in query.data) {
      return query.data?.pages.flatMap(({ items }) => items) || [];
    }
    return query.data?.items || [];
  }, [query.data, query.isLoading]);

export default useQueryData;
